import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    const user = localStorage.getItem("user");
    localStorage.clear();
    if (user == 'Administrador') {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/convenio/login']);
    }
  }

}
